module.exports = __webpack_public_path__ + "static/img/shibasaki-jamal.6b04bdb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shibasaki-jamal.jpg
// module id = u+j+
// module chunks = 0